import {
  useGetTriviaLeaderboardsQuery,
  useGetTriviaCategoryLeaderboardQuery,
  useGetTriviaDifficultyLeaderboardQuery,
  useGetTriviaStreakLeaderboardQuery,
  useGetTriviaSpeedLeaderboardQuery,
} from "../store/api/mlbApi";

/**
 * Custom hook for trivia leaderboards
 */
export const useTriviaLeaderboards = () => {
  const {
    data: globalData,
    isLoading: isLoadingGlobal,
    refetch: refetchGlobal,
  } = useGetTriviaLeaderboardsQuery({ type: "global" });
  const {
    data: streakData,
    isLoading: isLoadingStreak,
    refetch: refetchStreak,
  } = useGetTriviaStreakLeaderboardQuery();
  const {
    data: speedData,
    isLoading: isLoadingSpeed,
    refetch: refetchSpeed,
  } = useGetTriviaSpeedLeaderboardQuery();

  return {
    // Global leaderboard
    globalLeaderboard: globalData?.leaderboard || null,
    isLoadingGlobal,

    // Streak leaderboard
    streakLeaderboard: streakData?.leaderboard || null,
    isLoadingStreak,

    // Speed leaderboard
    speedLeaderboard: speedData?.leaderboard || null,
    isLoadingSpeed,

    // Loading state
    isLoading: isLoadingGlobal || isLoadingStreak || isLoadingSpeed,

    // Refetch function
    refetch: async () => {
      await Promise.all([refetchGlobal(), refetchStreak(), refetchSpeed()]);
    },
  };
};

/**
 * Custom hook for category leaderboards
 */
export const useTriviaCategoryLeaderboard = (category) => {
  return useGetTriviaCategoryLeaderboardQuery({ category });
};

/**
 * Custom hook for difficulty leaderboards
 */
export const useTriviaDifficultyLeaderboard = (difficulty) => {
  return useGetTriviaDifficultyLeaderboardQuery({ difficulty });
};
